module.exports = __webpack_public_path__ + "images/fujian_banner01.jpg?2fb02069b78c5f1ac767ed6edcbef4a2";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/fujian_banner01.jpg
// module id = 177
// module chunks = 1